import React from "react";

interface IButton {
  label: string;
  disabled?: boolean;
  onClick: () => void;
  //   type?: "primary" | "secondary";
}

const Button = ({ label, disabled = false, onClick }: IButton) => {
  return (
    <button
      onClick={onClick}
      className="uppercase font-bold rounded-full bg-complementary text-backgroundDark w-32 p-1 mt-2"
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;
